/**
 * TypeScript view of the `lits` format.
 * Source of truth: `shared/schema/lits.{definition,submission,solution,progress}.json`.
 */

export type Localized = Record<string, string | undefined>;

export interface LitsDefinition {
  puzzleType: "lits";
  typeVersion: number;
  rows: number;
  cols: number;
  /**
   * One string per row, one character per cell (A-Z, a-z, 0-9). A region is a maximal
   * orthogonally connected group of cells with the same character.
   */
  regions: string[];
  rulesText?: Localized;
  meta?: Record<string, unknown>;
}

export const SHADED = "#";
export const EMPTY = ".";
/** A solving aid: the player is sure the cell stays unshaded. Never sent to the server. */
export const DOT = "x";
export type CellState = typeof SHADED | typeof EMPTY | typeof DOT;

/** Autosave shape. Opaque to the core; this type owns it and its migrations. */
export interface LitsProgress {
  version: 1;
  /** One string per row, `#` shaded, `x` dotted, `.` undecided. */
  rows: string[];
}

/** One string per row, `#` shaded and `.` unshaded: dots are folded into `.`. */
export interface LitsSubmission {
  rows: string[];
}

/** The author's shading, in the submission format. */
export type LitsSolution = LitsSubmission;

export const MAX_SIZE = 20;
/** Cells in every region's piece. */
export const PIECE_SIZE = 4;
/** Characters a region grid may use, in the order the editor hands them out. */
export const REGION_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export type Cell = [row: number, col: number];

export function cellId(row: number, col: number): string {
  return `r${row}c${col}`;
}
